import i18n from "../i18n";

const LOCALE = { fr: "fr-FR", en: "en-GB", es: "es-ES" };

function loc() {
  return LOCALE[i18n.language?.slice(0, 2)] || "fr-FR";
}

// Locale (ex: 'en-GB') de la langue courante, pour formater dates/nombres.
export function dateLocale() {
  return loc();
}

// Libellé court du fuseau horaire du visiteur À LA DATE donnée (ex: "UTC+1" / "UTC+2" selon l'heure d'été).
export function tzLabel(date = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat(loc(), { timeZoneName: "short" }).formatToParts(date);
    const tz = parts.find((p) => p.type === "timeZoneName");
    return tz ? tz.value : "";
  } catch {
    return "";
  }
}

// Heure du coup d'envoi dans le fuseau du visiteur, suffixée du libellé du
// fuseau (ex: "20:00 CET") pour lever toute ambiguïté. Le libellé n'est ajouté
// que pour un vrai datetime ISO (pas pour une simple chaîne `time` serveur).
export function kickoffTimeTz(m) {
  const t = kickoffTime(m);
  const iso = m?.kickoff;
  const real = iso && typeof iso === "string" && iso.includes("T");
  const lbl = real ? tzLabel(new Date(iso)) : "";
  return real && t && lbl ? `${t} ${lbl}` : t;
}

// Kickoff time in the VISITOR's local timezone (24h). Only formats a real
// datetime (ISO containing a 'T'); returns the server `time` string otherwise.
export function kickoffTime(m) {
  const iso = m?.kickoff;
  if (iso && typeof iso === "string" && iso.includes("T")) {
    const d = new Date(iso);
    if (!isNaN(d)) return d.toLocaleTimeString(loc(), { hour: "2-digit", minute: "2-digit", hour12: false });
  }
  return m?.time || "";
}

// Kickoff date in the visitor's local timezone. Falls back to `date`.
export function kickoffDate(m, opts) {
  const iso = m?.kickoff;
  if (iso && typeof iso === "string" && iso.length >= 10) {
    // date-only strings are pinned to local noon to avoid a timezone day-shift
    const d = new Date(iso.includes("T") ? iso : `${iso.slice(0, 10)}T12:00:00`);
    if (!isNaN(d)) return d.toLocaleDateString(loc(), opts || { day: "2-digit", month: "2-digit" });
  }
  return m?.date || "";
}
